import _ from 'underscore';
import Promise from 'bluebird';

export class FilterPreferenceService {
  constructor({
    data,
  } = {}) {
    this.data = data || [];
  }

  findAll() {
    return Promise.resolve(this.data);
  }

  filter({
    where = {},
  } = {}) {
    if (where.name) {
      const index = _.findIndex(this.data, val => val.name === where.name);

      if (index >= 0) {
        return [this.data[index]];
      }
      return [];
    }

    return this.data;
  }

  create(value) {
    const data = _.defaults({
      id: _.uniqueId(),
    }, value);
    this.data.push(data);

    return Promise.resolve(data);
  }

  update(id, value) {
    const index = _.findIndex(this.data, val => val.id === id);

    if (index >= 0) {
      const result = _.defaults({
        id,
      }, value, this.data[index]);
      this.data.splice(index, 1, result);

      return Promise.resolve(result);
    }

    throw new Error(`data with id:${id} does not exist`);
  }

  destroy(id) {
    const index = _.findIndex(this.data, val => val.id === id);

    if (index >= 0) {
      this.data.splice(index, 1);
    } else {
      throw new Error(`data with id:${id} does not exist`);
    }

    return Promise.resolve(id);
  }
}
